import styled from "styled-components";

import { Link } from "react-router-dom";

import { theme } from "../../../styles/theme";

import LucralizeCadastro from "../../../assets/images/Lucralize-Cadastro.png";

export const Header = styled.header`
  width: calc(100% - 100px);
  background-color: ${theme.colors.blue900};
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  padding: 20px;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
  border-radius: 0 0 10px 10px;
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${theme.colors.blue900};
  position: relative;
  background-image: url(${LucralizeCadastro});
  background-size: 200px;
  background-position: bottom right;
  background-repeat: no-repeat;
`;

export const Title = styled.h1`
  font-size: ${theme.font.sizes.xxlarge};
  font-weight: ${theme.font.bold};
  color: ${theme.colors.white};
  margin-bottom: 40px;
  margin-top: 60px;
  text-align: center;
`;

export const TermsLink = styled(Link)`
  font-family: ${theme.font.poppins};
  font-weight: ${theme.font.normal};
  font-size: ${theme.font.sizes.normal};
  width: 100%;
  text-align: center;
  text-decoration: none;
  color: ${theme.colors.gray400};
  text-decoration: none;
  position: absolute;
  bottom: 20px;
`;

export const Card = styled.div`
  width: 600px;
  padding: 20px;
  background-color: ${theme.colors.white};
  border-radius: ${theme.border.mediumRadius};
  margin: 0 auto;
  font-family: ${theme.font.poppins};
  font-weight: ${theme.font.normal};
  font-size: ${theme.font.sizes.normal};
  color: ${theme.colors.blue400};
  display: flex;
  align-items: center;
  gap: 20px;
`;

export const CardImage = styled.img`
  object-fit: cover;
  width: 160px;
`;
